
// atm mapper objects
const atmRegistrationEvents = require('./atmmapper/registration');

module.exports = function ($rootScope, $q, Restangular, loginService, shopperService, atm, AtmLocalService) {
    function SignupService() {
        this._api = Restangular.withConfig(function (RestangularConfigurer) {
            RestangularConfigurer.setFullResponse(true);
          }).one('signup');
        this.atm = atm;
        this.AtmLocalService = AtmLocalService;

        this.isFormSubmittedSuccessfully = false;
    }

    SignupService.prototype.signup = function (args, reCaptchaConfig = {}) {
        // atm registration submitted
        this.atm.push(null, atmRegistrationEvents.submitted);

        const { token, action, version } = reCaptchaConfig;
        const reCaptchaPayload = token ? {
            GoogleReCaptchaResponse: token,
            Action: action,
            Version: version
        } : {};
        const signupPromise = this._api.doPOST(Object.assign(
            args,
            reCaptchaPayload
        ));
        const shopperPromise = signupPromise.then(function (signupResult) {
            return signupResult.data.Success
                ? $q.all([shopperService.getCurrentShopperDetails(), shopperService.getCurrentShopperPreferences()])
                : null;
        });
        return $q.all([signupPromise, shopperPromise])
            .then((promiseResults) => {
                const signupResult = promiseResults[0].data;
                if (signupResult.Success) {
                    this.isFormSubmittedSuccessfully = true;
                    const data = promiseResults[1][0];

                    // atm registration success
                    data.selectNewsLetter = args.selectNewsLetter;
                    data.eventID = promiseResults[0].headers('x-eventid');
                    /**
                     *  Used to display a message to the user in my account
                     *  if there was an issue linking there EDR card
                     */
                    if (!signupResult.EdrLinked) {
                        this.edrLinkingErrorMessage = signupResult.EdrMessage;
                    }

                    this.atm.push(data, atmRegistrationEvents.success);

                    $rootScope.$broadcast('signup:success');
                    loginService.onLogin(signupResult.LoginModel);
                }

                return signupResult;
            });
    };

    SignupService.prototype.registrationStart = function () {
        // check if this page was already visited (localStorage)
        const isRegistrationAlreadyVisited = this.AtmLocalService.getState('shop.authentication.signup') ? false : true;

        // send an analytics event when the user start a form registration
        this.atm.push(isRegistrationAlreadyVisited, atmRegistrationEvents.start);
    };

    SignupService.prototype.registrationAbandoned = function (lastDirtyField) {
        // check if the form was submitted successfully
        if (!this.isFormSubmittedSuccessfully) {
            // if not then trigger an analytics registerAbandoned event
            this.atm.push(lastDirtyField, atmRegistrationEvents.abandoned);
        }
    };

    return new SignupService();
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/signup/signup-service.js
 **/